import styled from "styled-components";

export const StaffingContainer = styled.div`
  .staffing-content-wrapper{
   background:var(--white); 
   min-height: calc(100dvh - 76px - 63px);
  }
`;

export const ActionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid var(--border-main);
  margin-bottom: 20px;

  .left {
    display: flex;
    gap: 10px;
  }

  .right {
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;

export const Strong = styled.strong`
  font-weight: bold;
  color: var(--text-color-blue);
`;
